import {PModuleType} from '@/enums/configs';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {MeasurementType} from '@/views/system/measurements/enums';
import {SpectrumYAxisType} from '@/enums/diagrams';

export interface SegmentBarDiagramItem {
  start: number;
  end: number;
  mode: number;
}

/*
  Интерфейс диаграммы
*/

export interface WaterfallSpectrumDiagramData {
  // Идентификатор
  id: string;

  // Наименование диаграммы
  name: string;

  // Идентификатор ПМ
  moduleId: number;

  // GUID ПМ
  moduleGUID: string;

  // тип ПМ
  moduleType: PModuleType;
}

export interface AngleDiagramData {
  // Идентификатор
  id: string;

  // Наименование диаграммы
  name: string;

  // Идентификатор ПМ
  moduleId: number;

  // GUID ПМ
  moduleGUID: string;

  // тип ПМ
  moduleType: PModuleType;

  // Измерение
  measurements: MeasurementData[];
}

export interface DiagramData {
  // Идентификатор
  id: string;

  // Наименование диаграммы
  name: string;

  // Идентификатор ПМ
  moduleId: number;

  // GUID ПМ
  moduleGUID: string;

  // тип ПМ
  moduleType: PModuleType;

  // Наименование диаграммы (модуль)
  moduleName: string;

  // Измерение
  measurement: MeasurementData;

  // Тип диаграммы
  measurementType: MeasurementType;

  // Наименование диаграммы (измерение)
  measurementName: string;

  // Верхняя граница
  topBoundary?: number;

  // Нижняя граница
  bottomBoundary?: number;

  // Далее идут настройки графика. Можно выделить в отдельный объект
  isYLogAxis?: boolean;

  color?: string;

  freqbandId?: number;

  hideZeroFrequency?: boolean;
}

/*
  Интерфейс диаграммы сигналов
*/

export interface SignalDiagramData {
  // Идентификатор
  id: string;

  // Наименование диаграммы
  name: string;

  // Идентификатор ПМ
  moduleId: number;

  // GUID ПМ
  moduleGUID: string;

  // тип ПМ
  moduleType: PModuleType;

  // Измерение
  measurement: MeasurementData;

  // Верхняя граница
  topBoundary?: number;

  // Нижняя граница
  bottomBoundary?: number;

  // Группировка диаграм, используется для группировки диаграм и создания якоря
  groupAlias?: string;

  // Далее идут настройки графика. Можно выделить в отдельный объект
  isYLogAxis?: boolean;

  color?: string;

  visible: boolean;
}

/*
  Интерфейс диаграммы спектров
*/

export interface SpectrumDiagramData {
  // Идентификатор
  id: string;

  // Наименование диаграммы
  name: string;

  // Идентификатор ПМ
  moduleId: number;

  // GUID ПМ
  moduleGUID: string;

  // тип ПМ
  moduleType: PModuleType;

  // Измерение
  measurement: MeasurementData;

  // Тип оси Y: виброскорость или виброускорение
  spectrumYAxisType?: SpectrumYAxisType;

  // Далее идут настройки графика. Можно выделить в отдельный объект
  isYLogAxis?: boolean;

  color?: string;

  freqbandId?: number;

  hideZeroFrequency?: boolean;
}

export class TrendOptions {
  enabled = false;
  startTsFlag = true;
  startTs = 0;
  monotonityFlag = false;
  metric = 0;
  threshold = 0;
  interval = 100;
  data: any = null;
  warn_ts: any = null;
  factors: any = null;
}
